
import React from 'react';
import style from './style.module.scss'; // won't generate a '.d.ts' file until component is included in the app
import {IProps, IHandlers} from './types';
import {Avatar, Chip} from '@material-ui/core';

const NS = 'ChipAvatar';

export default function ChipAvatar({}: IProps & IHandlers) {
  return (
    <div>
      <Chip color={"primary"} title={'Click here to view Beverage list'} className={style.wineChip}
            avatar={<Avatar src="images/tags/wine.svg" style={{backgroundColor: 'transparent'}} className={style.wineAvatar} />}
            label="Beverages"
      />
    </div>
  )
}

